<script>
	import base from "../stores/base";
	export let data = {};
</script>

<section class="UIImageAndText _{data.imagePosition}">
	<div class="UIImageAndText-text _{data.imagePosition}">
		<div>
			{@html data["text_" + $base.lang].split("\n").join("<br>")}
		</div>
	</div>
	<div class="UIImageAndText-img">
		<img src={data.image} alt="" />
	</div>
</section>

<style global>
	.UIImageAndText {
		max-width: 1400px;
		margin: 0 auto;
		padding: 1em 0;
	}
	:global(.pc) .UIImageAndText {
		display: flex;
		align-items: center;
		font-size: 1.1em;
		justify-content: flex-end;
	}
	:global(.pc) .UIImageAndText._left {
		flex-direction: row-reverse;
	}

	.UIImageAndText-text {
		padding: 1em 1em;
	}

	:global(.pc) .UIImageAndText-text {
		padding: 1em 1.5em;
		flex: 0 0 54%;
		max-width: 640px;
		z-index: 2;
	}
	:global(.pc) .UIImageAndText-text._right > div {
		margin-right: -10%;
	}
	:global(.pc) .UIImageAndText-text._left > div {
		margin-left: -10%;
	}

	.UIImageAndText-img > img {
		max-width: 100%;
	}
	:global(.pc) .UIImageAndText-img {
		flex: 0 0 46%;
	}
	:global(.sp) .UIImageAndText-img {
		padding-top: 1.5em;
	}
</style>
